import { useEffect, useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  checkPasswordChangeLink,
  checkPasswordCreateLink,
  passwordChangeFromLink,
  passwordCreateFromLink,
} from '../../actions/security';
import PasswordChangeFrom from '../Security/ForgottenPassword/PasswordChangeForm';
import LoginFormWithImageWrapper from '../Security/LoginFormWithImageWrapper';
import styles from '../../styles/css/Login.module.css';
import withTranslations from '../../utils/HighOrderComponent';
import LoadingIndicator from '../Reusable/LoadingIndicator';
import { locationPath } from '../../constants/app-routes';

const PasswordChangeFromLink = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { uuid } = useParams();
  const { t, gt } = props || {},
    { title, titleCreatePassword, NotificationMessages } = t || {};
  const { loading } = useSelector((state) => state.loggedUserReducer);
  const { pathname } = history.location;
  const isCreatedUserFromLinkWithoutId = pathname?.includes(
    locationPath.CREATE_USER_FROM_LINK_WITHOUT_ID
  );

  useEffect(() => {
    const action = isCreatedUserFromLinkWithoutId
      ? checkPasswordCreateLink
      : checkPasswordChangeLink;
    dispatch(action(uuid, history));
  }, [dispatch, history, isCreatedUserFromLinkWithoutId, uuid]);

  const callback = () => history.push('/');

  const onSubmitHandler = (requestData) => {
    const action = isCreatedUserFromLinkWithoutId
      ? passwordCreateFromLink
      : passwordChangeFromLink;
    dispatch(action(uuid, requestData, callback, NotificationMessages));
  };

  const titlePage = useMemo(() => {
    return isCreatedUserFromLinkWithoutId ? titleCreatePassword : title;
  }, [isCreatedUserFromLinkWithoutId, title, titleCreatePassword]);

  return (
    <LoginFormWithImageWrapper
      title={titlePage}
      styles={styles}
      backToLoginLabel={true}
    >
      <LoadingIndicator loading={loading} />
      <PasswordChangeFrom gt={gt} t={t} onSubmit={onSubmitHandler} />
    </LoginFormWithImageWrapper>
  );
};

export default withTranslations(PasswordChangeFromLink, 'PasswordChangeForm');
